import { render, staticRenderFns } from "./base-text-field.vue?vue&type=template&id=0014480c&scoped=true"
import script from "./base-text-field.vue?vue&type=script&setup=true&lang=js"
export * from "./base-text-field.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-text-field.vue?vue&type=style&index=0&id=0014480c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014480c",
  null
  
)

export default component.exports